import { render, staticRenderFns } from "./WorkIconWidget.vue?vue&type=template&id=59d3620e"
import script from "./WorkIconWidget.vue?vue&type=script&lang=js"
export * from "./WorkIconWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports